import graphql__13f9a02d6c5cb270349e from "./__generated__/UpdateContactRolesDialog_customerAccount.graphql.ts";
import graphql__adbbffbe75c653a087a2 from "./__generated__/UpdateContactRolesDialog_contact.graphql.ts";
import graphql__b8ed9774ff0e7e1d023a from "./__generated__/UpdateContactRolesDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Row from "../form/Row";
import Hint from "../presentational/Hint";
import FormDialog from "../dialog/FormDialog";
import Checkbox from "../form/Checkbox";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useIntl} from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";

type Role = {
    roleIdentifier: string
}

type Props = {
    customerAccount: any,
    contact: any
    roles: Role[]
    handleCloseDialog: () => {}
}

const UpdateContactRolesDialog: React.FC<Props> = (props) => {
    const intl = useIntl();
    const customerAccount = useFragment(
        graphql__13f9a02d6c5cb270349e,
        props.customerAccount
    );

    const contact = useFragment(
        graphql__adbbffbe75c653a087a2,
        props.contact
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        input.contactRoles = input.contactRoles.map((roleIdentifier) => {
            return {"roleIdentifier": roleIdentifier}
        })
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__b8ed9774ff0e7e1d023a,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    props.handleCloseDialog();
                },
                onError: (error) => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToUpdateContactRoles'})
            }
        )
    }

    const initialValues = {
        customerAccountIdentifier: customerAccount.id,
        contactIdentifier: contact.id,
        contactRoles: props.roles.map((role) => {
            return role.roleIdentifier
        })
    }

    const contactName = (contact.teamName || ((contact.givenName ?? "") + " " + (contact.familyName ?? ""))).trim() || intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.unknown'});

    return (
        <FormDialog handleCloseDialog={props.handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} headline={intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.headline'})} submitLabel={intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.submitLabel'})}>
            <Section>
                <Row>
                    <p>{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.instruction'}, {contact: <strong>{contactName}</strong>, customer: <strong>{customerAccount.customerName}</strong>})}</p>
                </Row>
                <Row>
                    <fieldset className="border-t border-b border-gray-200">
                        <div className="divide-y divide-gray-200">
                            <div className="relative flex items-start py-4">
                                <div className="min-w-0 flex-1 text-sm">
                                    <label className="font-medium text-gray-700">{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.role.primaryContact.label'})}</label>
                                    <p className="text-gray-500">{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.role.primaryContact.description'})}</p>
                                </div>
                                <div className="ml-3 flex items-center h-5">
                                    <Checkbox name="contactRoles" value="PrimaryContact"/>
                                </div>
                            </div>
                            <div className="relative flex items-start py-4">
                                <div className="min-w-0 flex-1 text-sm">
                                    <label className="font-medium text-gray-700">{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.role.security.label'})}</label>
                                    <p className="text-gray-500">{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.role.security.description'})}</p>
                                </div>
                                <div className="ml-3 flex items-center h-5">
                                    <Checkbox name="contactRoles" value="Security"/>
                                </div>
                            </div>
                            <div className="relative flex items-start py-4">
                                <div className="min-w-0 flex-1 text-sm">
                                    <label className="font-medium text-gray-700">{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.role.technical.label'})}</label>
                                    <p className="text-gray-500">{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.role.technical.description'})}</p>
                                </div>
                                <div className="ml-3 flex items-center h-5">
                                    <Checkbox name="contactRoles" value="Technical"/>
                                </div>
                            </div>
                            <div className="relative flex items-start py-4">
                                <div className="min-w-0 flex-1 text-sm">
                                    <label className="font-medium text-gray-700">{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.role.billing.label'})}</label>
                                    <p className="text-gray-500">{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.role.billing.description'})}</p>
                                </div>
                                <div className="ml-3 flex items-center h-5">
                                    <Checkbox name="contactRoles" value="Billing"/>
                                </div>
                            </div>
                            <div className="relative flex items-start py-4">
                                <div className="min-w-0 flex-1 text-sm">
                                    <label className="font-medium text-gray-700">{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.role.legal.label'})}</label>
                                    <p className="text-gray-500">{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.role.legal.description'})}</p>
                                </div>
                                <div className="ml-3 flex items-center h-5">
                                    <Checkbox name="contactRoles" value="Legal"/>
                                </div>
                            </div>
                            <div className="relative flex items-start py-4">
                                <div className="min-w-0 flex-1 text-sm">
                                    <label className="font-medium text-gray-700">{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.role.invoiceRecipient.label'})}</label>
                                    <p className="text-gray-500">{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.role.invoiceRecipient.description'})}</p>
                                </div>
                                <div className="ml-3 flex items-center h-5">
                                    <Checkbox name="contactRoles" value="InvoiceRecipient"/>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </Row>
                <Row>
                    <Hint>{intl.formatMessage({id: 'dialog.UpdateContactRolesDialog.hint'}, {contact: <strong>{contactName}</strong>})}</Hint>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default UpdateContactRolesDialog;
